import maInputText from '@/components/input/modules/text'
import routesBuilderMixin from '@/mixins/authRoutesBuilder'

/**
 * @module
 * @name Login
 */
export default {
  name: 'Login',

  mixins: [routesBuilderMixin],

  components: {
    maInputText
  },

  computed: {
    disableLoginButton: function () {
      return this.user.username.length <= 0 ||
             this.user.password.length <= 0
    },
    showMaLogo: function () { return this.$maDomain },
    loginTitle: function () {
      if (this.$maDomain) {
        return this.$t('login.titleMA')
      } else {
        return this.$t('login.title')
      }
    }
  },

  methods: {
    handleEnter: function () {
      if (!this.disableLoginButton) {
        localStorage.setItem('user_manual', 'true')
        this.sendLogin(true)
      }
    },

    handleChangeForm (v) {
      let vm = this
      if (v.inputId && v.inputVal !== null) {
        vm.user[v.inputId] = v.inputVal
      }
    }
  }

}
